
document.addEventListener("DOMContentLoaded", function () {
  function getActiveVariantId() {
    // ShopifyAnalytics è disponibile nella maggior parte dei temi
    return window.ShopifyAnalytics?.meta?.selectedVariantId ||
           document.querySelector('input[name="variantId"]')?.value ||
           document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
  }

  async function fetchMetafield(variantId) {
    try {
      const response = await fetch(`/variants/${variantId}.json`);
      if (!response.ok) throw new Error("Errore nel recupero variante");
      const data = await response.json();
      return data?.variant?.metafields?.custom?.omnibus_price_history || null;
    } catch (err) {
      console.error("Errore fetching metafield JSON:", err);
      return null;
    }
  }

  async function showLowestPriceMessage() {
    const variantId = getActiveVariantId();
    if (!variantId) return;

    try {
      const res = await fetch(`/admin/api/2023-10/variants/${variantId}/metafields.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "include"
      });

      const data = await res.json();
      const meta = data.metafields?.find(
        m => m.namespace === "custom" && m.key === "omnibus_price_history"
      );

      if (!meta || !meta.value) return;

      const json = JSON.parse(meta.value);
      const lowest = parseFloat(json?.lowest_30_days?.price);
      const currentPriceEl = document.querySelector('[data-product-price], .product__price, .price-item--regular');

      if (!currentPriceEl || isNaN(lowest)) return;

      const currentPriceText = currentPriceEl.textContent.replace(/[^\d.,]/g, "").replace(",", ".");
      const current = parseFloat(currentPriceText);

      if (lowest > current) {
        const msg = document.createElement("div");
        msg.innerHTML = `<strong>Prezzo più basso ultimi 30gg:</strong> €${lowest.toFixed(2).replace(".", ",")}`;
        msg.className = "lowest-price-omnibus";
        msg.style.marginTop = "10px";
        msg.style.fontSize = "16px";
        msg.style.color = "#444";
        currentPriceEl.parentNode.insertBefore(msg, currentPriceEl.nextSibling);
      }
    } catch (e) {
      console.error("Errore generico:", e);
    }
  }

  showLowestPriceMessage();
});
